import type { Permission } from '@sahab/contracts'

/**
 * What each purchasing "new document" page really needs (UX only: the API enforces the same), the
 * purchasing half of `CREATE_ACCESS` (pages/purchasing.md X-7, PU-60). The purchase form needs only
 * its create permission. The payment, return and refund forms also list the supplier's open
 * purchases or credit, which the API serves under `purchasing.read`, so they need it too. The route
 * guards, the supplier profile and the row actions all read this one table.
 */
export const PURCHASING_ACCESS = {
  purchase: ['purchases.create'],
  supplierPayment: ['supplierPayments.create', 'purchasing.read'],
  supplierReturn: ['supplierReturns.create', 'purchasing.read'],
  supplierRefund: ['supplierRefunds.create', 'purchasing.read'],
} as const satisfies Record<string, readonly Permission[]>
